import { requestWrapper } from 'e-submission/domain/data'

export const searchLuckyNumberOptions = (user, payload) => {
  return requestWrapper.postRequest(`esub/get-lucky-number-policies`, user, payload).then(({ data }) => data)
}

export const submitSelectedLuckyNumber = (user, payload) => {
  return requestWrapper.postRequest('esub/update-status-lucky-number-policies', user, payload).then(({ data }) => data)
}
